import {
  ICounselorAgentRequest,
  ICounselorExecutionRequest,
  ICounselorGuideCoaching,
  ICounselorHealth,
  IDataBlock,
  IExecutionResultResponse,
  IUpdateWeightsRequest,
} from 'src/@types/apiResponse';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

/** 데이터 분석 및 코칭 안내 생성 */
export const executeResult = async (request: ICounselorExecutionRequest) => {
  try {
    const url = `/counselor/executions/result`;

    const response = await instance.post<IExecutionResultResponse>(url, request);
    return response.data;
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('[Counselor] executeResult failed:', error);
    }
  }
};

/** 일정 코칭(미션 추천) 결과 조회 */
export const getGuideCoaching = async () => {
  try {
    const url = `/counselor/guide-coaching`;

    const response = await instance.get<TApiResponseData<ICounselorGuideCoaching>>(url);
    return response.data;
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('[Counselor] getGuideCoaching failed:', error);
    }
  }
};

/** 콘텐츠 추천 밴딧 파라미터 업데이트 */
export const updateWeights = async (request: IUpdateWeightsRequest) => {
  try {
    const url = `/counselor/recommendation/weights`;

    const response = await instance.put<TApiResponseData<{ success: boolean }>>(url, request);
    return response.data;
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('[Counselor] updateWeights failed:', error);
    }
  }
};

/** 개별 에이전트 실행 (갈망 버튼 등) */
export const executeAgent = async (request: ICounselorAgentRequest) => {
  try {
    const url = `/counselor/agents/executions`;

    const response = await instance.post<TApiResponseData<IDataBlock[]>>(url, request);
    return response.data;
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('[Counselor] executeAgent failed:', error);
    }
  }
};

/** 카운셀러 서버 헬스체크 */
export const getHealth = async () => {
  try {
    const url = `/counselor/health`;

    const response = await instance.get<TApiResponseData<ICounselorHealth>>(url);
    return response.data;
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('[Counselor] getHealth failed:', error);
    }
  }
};
